<ion-grid class="toolbar-bar">
    <ion-row>
        <ion-col size="6" class="col-flex">
            <div [style.border-color]="getFrColor()" class="icon-circle centered thumb-circle" id="thumbup-icon"
                (click)="onToogleThumb()">
                <!-- <img class="img-svg" src="/assets/imgs/thumbs-up-regular-{{ stateThumb }}.svg"> -->
                <ion-icon name="thumbs-up" style="transform: scale(1.3);" [style.color]="getFrColor()"></ion-icon>
            </div>
            <span class="small-text"  (click)="onPageLoad('thumbup', $event)">
                {{ congrats?.length }}
                {{ 'PUBLICPROFILE_GRATULATIONS' | translate }}</span>
        </ion-col>
        <div class="toolbar-bar-split">
            |
        </div>
        <ion-col class="col-flex content-end" (click)="onPageLoad('comment', $event)">

            <span class="small-text">
                {{ resultDetails?.commentCount }}
                {{ 'RESULT_COMMENTS' | translate }}</span>
            <div class="icon-circle centered comment-circle" (click)="onToogleComment()">
                <img class="img-svg" src="/assets/imgs/comment-{{ stateComment }}.svg">
            </div>
        </ion-col>
    </ion-row>
</ion-grid>